import React from "react";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
class SidebarItem extends React.Component {

    onClick = (e) => {
        if (this.props.onClick) {
            const result = { ...this.props };
            delete result.onClick;
            result.key = result.sectionKey;
            delete result.sectionKey;
            this.props.onClick(e, result.index, result.key, result);
        }
    }

    get defaultPlacement() {
        return "bottom";
    }

    get overlay() {
        return (
            <OverlayTrigger delay={{ show: 10, hide: 0 }} overlay={<Tooltip>{this.props.tooltip}</Tooltip>} placement={this.props.overlayPlacement || this.defaultPlacement}>
                {this.link}
            </OverlayTrigger>
        );
    }

    get link() {
        return <Button variant="link" onClick={this.onClick} className={`fera-section-browser__caption ${this.props?.active ? "active" : ""}`}>{ this.props?.caption }</Button>
    }
    
    render() {
        return (
            <div className={`fera-section-browser__item ${this.props?.active ? "active" : ""}`}>
                <Button
                    variant="link"
                    onClick={this.onClick}
                    className="fera-section-browser__icon-button"
                    aria-label={`Open ${this.props?.caption || "survey section"}`}
                >
                    <span className="fera-section-browser__icon">
                        <i className={`fera-section-browser__glyph ${this.props?.icon}`} style={{ color: this.props?.iconColor || "var(--alternate)" }} />
                    </span>
                </Button>
                {this.props.tooltip ? this.overlay : this.link}
            </div>
        )
    }
}

export default SidebarItem;
